/** funciones para el modulo de solicitudes masivas en proceso */
import axiosMailUpdate from '../services/axiosApi'
var inProcessRequests = {
    async getMasiveRequestsInProcess() {
        const response = await axiosMailUpdate.get('api/v1/request/inprocess?sort_by=created_at')
        this.response = response.data.data
        return this.response
    },
    async closeRequest(idRequest) {
        const response = await axiosMailUpdate.put('api/v1/requests/'+idRequest+'/closed')
        this.response = response.data.data
        return this.response
    },
}
export default inProcessRequests